import { render, staticRenderFns } from "./OrderDetailNotes.vue?vue&type=template&id=deee891a&scoped=true"
import script from "./OrderDetailNotes.vue?vue&type=script&lang=js"
export * from "./OrderDetailNotes.vue?vue&type=script&lang=js"
import style0 from "./OrderDetailNotes.vue?vue&type=style&index=0&id=deee891a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "deee891a",
  null
  
)

export default component.exports